import React, { useEffect } from "react";
import "../styles/CustomerSupport.css";
import { useDispatch, useSelector } from "react-redux";
import { termAndConditions } from "../actions/footerActions";
import { Helmet } from 'react-helmet-async'; // Import Helmet

// import Loader from "../loader/Loader-ui";

const TermsAndConditions = () => {

  // const dispatch = useDispatch();
  // const terms = useSelector((state) => state.footer);
  
  // useEffect(() => {
  //   dispatch(termAndConditions());
  // }, [dispatch])
  // const htmlContext = terms?.termsAndConditions?.data?.terms_and_conditions[0].body;
  return (
    <>
    {/* Helmet for SEO Metadata */}
    <Helmet>
        <title>Terms and Conditions | Fundswala</title>
        <meta 
          name="description" 
          content="Read the Terms and Conditions of Fundswala. Learn about our policies, privacy, and your rights while using our platform." 
        />
      </Helmet>
    <div className="container-fluid page_background">

      <div className="page-inner-content mb-4">
        <div className="page_inner_content_box">
          <h5
            className="mb-4 main-heading-title heading-size text-center"
            style={{ fontSize: "40px" }}
          >
            Terms and Conditions
          </h5>
          <div className="container mt-5">
            {/* Safely render the HTML content */}
            {/* <div dangerouslySetInnerHTML={{ __html: htmlContext }}></div> */}

<p>
        This Privacy Policy describes our policies and procedures on the
        collection, use and disclosure of your information when you use the
        Service and informs you about your privacy rights and how the law
        protects you.
      </p>
      <p>
        We use your personal data to provide and improve the Service. By using
        the Service, you agree to the collection and use of information in
        accordance with this Privacy Policy.
      </p>

      <h5 className="font-bold">Interpretation and Definitions</h5>
      <h5 className="font-bold">Interpretation</h5>
      <p>
        The words with capitalized first letters have meanings defined under the
        following conditions. These definitions shall have the same meaning
        regardless of whether they appear in singular or plural.
      </p>

      <h5 className="font-bold">Definitions</h5>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Account</strong> A unique account created for you to access
          our Service.
        </li>
        <li>
          <strong>Company</strong> Refers to Fundswala (An initiative by VNP
          Mutual Fund Services Private Limited).
        </li>
        <li>
          <strong>Cookies</strong> Small files placed on your device containing
          browsing history.
        </li>
        <li>
          <strong>Country</strong> Uttar Pradesh, India.
        </li>
        <li>
          <strong>Device</strong> Any device that can access the Service (e.g.
          computer, cellphone, tablet).
        </li>
        <li>
          <strong>Personal Data</strong> Any information that relates to an
          identified or identifiable individual.
        </li>
        <li>
          <strong>Service</strong> Refers to the Fundswala Website.
        </li>
        <li>
          <strong>Service Provider</strong> Any third party who processes data
          on behalf of the Company.
        </li>
        <li>
          <strong>Usage Data</strong> Data collected automatically by using the
          Service (e.g. visit duration, pages visited).
        </li>
        <li>
          <strong>Website</strong> Fundswala, accessible from{" "}
          <a
            href="http://fundswala.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            http://fundswala.com/privacy-policy/
          </a>
        </li>
        <li>
          <strong>You</strong> The individual or entity using the Service.
        </li>
      </ul>

      <h5 className="font-bold">Collecting and Using Your Data</h5>
      <h5 className="font-bold">Types of Data Collected</h5>
      <p>We may collect the following personal data:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Phone number</li>
        <li>Address (State, Province, ZIP/Postal code, City)</li>
      </ul>

      <h5 className="font-bold">Usage Data</h5>
      <p>
        Usage Data is collected automatically and may include IP address,
        browser type, pages visited, time spent, device info, etc.
      </p>

      <h5 className="font-bold">Tracking Technologies and Cookies</h5>
      <p>
        We use Cookies, Web Beacons, Flash Cookies, and similar tracking
        technologies to enhance and analyze usage of the Service.
      </p>

      <h5 className="font-bold">Types of Cookies We Use</h5>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Essential Cookies</strong> Enable core features like
          authentication.
        </li>
        <li>
          <strong>Policy Acceptance Cookies</strong> Track whether users have
          accepted cookies.
        </li>
        <li>
          <strong>Functionality Cookies</strong> Remember user preferences such
          as login or language.
        </li>
      </ul>

      <h5 className="font-bold">Use of Your Personal Data</h5>
      <ul className="list-disc pl-6 space-y-1">
        <li>To provide and maintain our Service</li>
        <li>To manage Your account and profile</li>
        <li>To perform contracts or transactions</li>
        <li>To contact You via email, SMS, or app notifications</li>
        <li>To share offers or promotions</li>
        <li>To handle support and requests</li>
        <li>For business transfers (e.g. merger or acquisition)</li>
        <li>For data analysis and performance improvement</li>
      </ul>

      <h5 className="font-bold">Data Sharing and Disclosure</h5>
      <ul className="list-disc pl-6 space-y-1">
        <li>With Service Providers</li>
        <li>For business transfers</li>
        <li>With affiliates and business partners</li>
        <li>With your consent</li>
      </ul>

      <h5 className="font-bold">Data Retention</h5>
      <p>
        We retain your Personal Data only as long as necessary to fulfill the
        purposes outlined in this policy, comply with legal obligations, and
        resolve disputes.
      </p>

      <h5 className="font-bold">Children's Privacy</h5>
      <p>
        We do not knowingly collect personal information from children under the
        age of 13. If we become aware, we take steps to delete such data.
      </p>

      <h5 className="font-bold">External Links</h5>
      <p>
        Our Service may link to third-party websites. We are not responsible for
        their content or privacy practices.
      </p>

      <h5 className="font-bold">Changes to This Privacy Policy</h5>
      <p>
        We may update our Privacy Policy from time to time. Changes will be
        notified via email or on the website. You are encouraged to review this
        page periodically.
      </p>

      <h5 className="font-bold">Contact Us</h5>
      <p>
        If you have any questions about this Privacy Policy, you can contact us
        at:{" "}
        <a
          href="mailto:vishal.kokate@fundswala.com"
          className="text-blue-500 underline"
        >
          vishal.kokate@fundswala.com
        </a>
      </p>
            <div>

            </div>
          </div>
        </div>
      </div>

      {/* <Loader /> */}



    </div>
    </>
  );
};

export default TermsAndConditions;
